module.exports = __webpack_public_path__ + "image/solution_list_img2.jpg";